export default "__VITE_ASSET__aa1e254b__"